import { Link } from "react-router-dom";
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";


import MDBox from "ui/MDBox";
import MDTypography from "ui/MDTypography";
import MDAlert from "ui/MDAlert";


import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

// Data
import authorsTableData from "layouts/roles-management/data";
import { useEffect, useState } from "react";
import MDButton from "ui/MDButton";
import { Icon } from "@mui/material";
import Notification from "examples/Notifications";
import roleService from "services/role-service";

const RolesManagement = () => {
  const [notification, setNotification] = useState(false);
  const [roles, setRoles] = useState([]);
  const [tableData, setTableData] = useState(null);

  const handleDelete = async (roleId) => {
    const response = await roleService.delete(roleId);
    setRoles((prevRoles) => prevRoles.filter(role => role.id !== roleId));
    if (response.success) {
      setNotification({
        type: 'success',
        message: response.message,
      });
    } else {
      setNotification({
        type: 'error',
        message: response.errors[0],
      });
    }
  };

  // const { columns, rows } = authorsTableData(employees, handleDelete);
  // console.log('columns', rows);

  useEffect(() => {
    const vals = authorsTableData(roles, handleDelete);
    setTableData(vals);
  }, [roles])

  useEffect(() => {
    getRoles();
  }, []);

  const getRoles = async() => {
    var rolesData = await roleService.getAll();
    if (rolesData.success) {
      console.log('roles-data', rolesData.roles);
      setRoles(rolesData.roles);
    }
  }
 
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex" justifyContent="space-between" alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  Roles
                </MDTypography>
                <MDButton component={Link} to={'/roles/create'} color="light">
                  <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                  &nbsp;Add
                </MDButton>
              </MDBox>
              <Notification notification={notification} setNotification={setNotification} />
             {tableData && 
                <MDBox pt={3}>
                <DataTable
                  table={tableData}
                  isSorted={true}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  
                />
              </MDBox>
              }
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default RolesManagement;
